import { render, staticRenderFns } from "./CasosDadosDeAlta.vue?vue&type=template&id=55a3bced&"
import script from "./CasosDadosDeAlta.vue?vue&type=script&lang=js&"
export * from "./CasosDadosDeAlta.vue?vue&type=script&lang=js&"
import style0 from "./CasosDadosDeAlta.vue?vue&type=style&index=0&id=55a3bced&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports